import React, { useEffect, useState } from "react";
import { Box, Typography, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ordersPathTo } from '../utils/Api';
import OrderCard from "./OrderCard";
import PageHeader from "./building_blocks/PageHeader";
import { layoutCardRadius } from '../theme/colors';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const result = await ordersPathTo.list({ with_logo: true, with_items: true });
        setOrders(result.data.orders || []);
        setIsLoading(false);
      } catch (error) {
        console.error('Erro ao carregar pedidos:', error);
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const latestFinalizedOrder = orders.find((order) => (
    order.status === 'done' &&
    order.provider?.published === true
  )) || null;

  const sortedOrders = [...orders].sort((a, b) => (b.id || 0) - (a.id || 0));

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (latestFinalizedOrder) {
      localStorage.setItem('latestOrder', JSON.stringify(latestFinalizedOrder));
      localStorage.setItem('latestOrders', JSON.stringify([latestFinalizedOrder]));
    } else {
      localStorage.removeItem('latestOrder');
      localStorage.removeItem('latestOrders');
    }
  }, [isLoading, latestFinalizedOrder]);

  const renderEmptyMessage = (message) => (
    <Card sx={{ display: 'flex', padding: '24px', alignItems: 'center', alignSelf: 'stretch', bgcolor: 'surface.card', borderRadius: layoutCardRadius }}>
      <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '24px', color: '#546E7A' }}>
        {message}
      </Typography>
    </Card>
  );

  const renderOrderList = () => {
    if (isLoading) {
      return renderEmptyMessage('Carregando...');
    }

    if (sortedOrders.length === 0) {
      return renderEmptyMessage('Você ainda não tem pedidos');
    }

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignSelf: 'stretch', width: '100%' }}>
        {sortedOrders.map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            handleCardClick={() => navigate('/orders/' + order.id)}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 3 }}>
      <PageHeader title="Histórico de Pedidos" onBack={() => window.history.back()} />

      {renderOrderList()}
    </Box>
  );
};

export default MyOrders;
